import React from 'react';
import { FullPageError, FullPageErrorDescription, FullPageErrorTitle } from '@cko/primitives';

export const NoAccessPage = () => {
  return (
    <FullPageError>
      <FullPageErrorTitle>Access is restricted</FullPageErrorTitle>
      <FullPageErrorDescription>
        Speak to your administrator to gain access.
      </FullPageErrorDescription>
    </FullPageError>
  );
};
